<template>
    <div>
        <div class="my-car-number" :style="{'max-height':hh+'px'}">
            <div class="car-tab">

                <div class="top-title">
                    <span @click="(historyData.length > 0 || myCarData.length >0) ? manage = !manage :''">我的车牌</span>
                    <span @click=" (historyData.length > 0 || myCarData.length >0) ? manage = !manage :''" v-show="!manage">管理</span>
                    <span v-show="manage" class="save-btn" @click="saveManage">保存</span>
                </div>

                <div class="title-description">
                    <span>已添加车牌</span>
                    <span>永久保存，首车牌自动导入</span>
                </div>

                <div class="car-list">

                    <div v-show="myCarData.length>0">

                        <div :class="!manage ? 'list-member active':'list-member'" v-for="(item,index) in myCarData" :key="item.id"  @click="!manage ? selete(item):''">

                            <div class="list-left">
                                <p :class="{green:((''+item.provice + item.number).length > 7 ? true : false)}">
                                    <span>
                                        <em>{{item.provice}}</em>
                                        <em>•</em>
                                        <em>{{item.number}}</em>
                                    </span>
                                </p>
                            </div>

                            <div class="search" v-show="!manage"><i class="iconfont icon-sousuo1"></i></div>


                            <div class="list-right" v-show="manage">

                                <p class="del-history" @click="Delete(item)">删除</p>
                                <p v-show="index != myCarData.length-1" @click="move(index,item,1)">下移</p>
                                <p v-show="index != 0" @click="move(index,item,-1)">上移</p>

                            </div>

                        </div>
                    </div>

                    <p class="car-null" v-show="myCarData.length == 0">在下方历史或查找页面加入车牌</p>

                </div>


                <div class="title-description">
                    <span>查找历史</span>
                    <span>保存上限8个，超过清除</span>
                </div>


                <div class="search-history">

                    <div class="history-data" v-show="historyData.length>0">

                        <div :class="!manage ? 'history-all active':'history-all'" v-for="(item,index) in historyData" :key="item.id" v-if="index < 8">
                            <span class="history-number">{{item.name}}</span>
                            <span class="set-main" v-show="!manage" @click="setMainCarN(item)">设主车牌</span>
                            <span class="del-history" v-show="manage" @click="delHistory(item)">删除</span>
                            <i v-show="!manage" class="iconfont icon-sousuo1" @click="selete(item)"></i>
                        </div>

                    </div>

                    <div class="his-null" v-show="historyData.length==0">
                        <img src="../../../../../public/images/zanwu.png" alt="">
                        <p>暂无历史，请返回查找页面</p>
                    </div>

                </div>
            </div>
            <div class="line-end">
                <div class="fg"></div>
                <div class="font">我是有底线的</div>
                <div class="fg"></div>
            </div>
            <div class="close">
                <div class="close-radius" @click="closeMyCar"><i class="iconfont icon-close-02"></i></div>
                <div class="line"></div>
            </div>
        </div>

    </div>
</template>

<script>
export default {

    props: {

        historyData:{//查找历史
            type: Array,
            default: () => {
                return []
            }
        },
        myCarData:{
            type: Array,
            default: () => {
                return []
            }
        },

        hh:{//盒子高度
            type: String,
        }
    },

    data() {
        return {
            moveUp:false,
            moveDown:false,
            manage: false,//管理标识
        };
    },

    created(){

        this.bus.$on('myCarClose',()=>{
            this.closeMyCar();
        })

    },
    methods:{

        //上下移动
        move(index,item,step){
            // console.log('index',index,'item',item);
            this.myCarData[index] = this.myCarData.splice((index + step),1,this.myCarData[index])[0];
        },


        //保存管理
        saveManage(){
            // console.log('保存数据');

            this.moveUp=false;
            this.moveDown=false;
            this.manage=false;
            this.$emit('save')
        },


        //删除查找历史
        delHistory(item){

            // console.log('删除查找历史',item);
            //删除
            this.historyData.filter((ITEM,index,self)=>{
                if(ITEM.id == item.id){
                    this.historyData.splice(index,1)
                }
            })

        },

        Delete(item){
            // console.log('删除数据',item);

            this.myCarData.filter((ITEM,index,self)=>{
                if(ITEM.id == item.id){
                    this.myCarData.splice(index,1)
                }
            })

        },

        //关闭
        closeMyCar(){

            this.manage = false;
            this.moveUp=false;
            this.moveDown=false;
            this.$emit('childClose',false)
        },

        //设置主车牌
        setMainCarN(ITEM){


            let mID = this.myCarData.length > 0 ? (this.myCarData.sort((v1,v2)=>{
                    return v2.id - v1.id;
                })[0].id + 1) : 0,

                $carN = ITEM.name,

                $mArr = this.myCarData.filter((item,index,self)=>{

                    let $itemCarN = item.provice + item.number;
                    if($itemCarN == $carN){//交换位置
                        let $temp = item;

                        this.myCarData.splice(index,1);   //删除该元素

                        this.myCarData.unshift($temp);

                        this.$message.info('车牌已存在，勿重复添加');
                    }

                    return $itemCarN == $carN;
                })

            //追加元素
            if($mArr.length == 0){

                this.myCarData.unshift({
                    id:mID,
                    provice:$carN.slice(0,2),
                    number:$carN.slice(2,$carN.length)
                });

            }

            this.$emit('save');

        },

        //选中
        selete(item){
            // console.log('选中项目item',item);

            let $value = '';

            if(item.provice){   //保存车牌号
                $value = item.provice + item.number
            }else{ //历史数据保存
                $value = item.name;
            }

            this.$emit('childClose',false);
            this.$emit('resulte',$value)
        }
    },

    mounted(){

        // console.log('this.myCarData',this.myCarData);
    }
};
</script>

<style scoped lang="less">
    @import "../../../../styles/cssBlock";
    @import "./MyCar";
</style>
